import React from 'react';

const WelcomeBanner = ({
  studentName,
  selectedTerm, // Pass selectedTerm from parent (e.g., "first", "second", "third")
  className = ''
}) => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 17) return 'Good Afternoon';
    return 'Good Evening';
  };

  // Get first letter of student name for avatar
  const getInitial = (name) => {
    return name && typeof name === 'string' && name.length > 0
      ? name.charAt(0).toUpperCase()
      : 'S';
  };

  // Get current year and selected term for academic year display
  const getAcademicYear = () => {
    const year = new Date().getFullYear();
    const termLabel = selectedTerm
      ? ({
          first: 'First Term',
          second: 'Second Term',
          third: 'Third Term'
        }[selectedTerm.toLowerCase()] || selectedTerm)
      : 'N/A';
    return `${year} • ${termLabel}`;
  };

  return (
    <div className={`relative flex items-center bg-gradient-to-r from-primary to-accent p-8 rounded-2xl mb-6 shadow-lg overflow-hidden ${className}`}>
      {/* Overlay for better contrast */}
      <div className="absolute inset-0 bg-black/10 md:bg-black/20 pointer-events-none rounded-2xl" />
      {/* Modern Avatar */}
      <div className="flex-shrink-0 mr-6 z-10">
        <div className="w-20 h-20 rounded-full bg-white flex items-center justify-center text-4xl font-bold text-primary shadow-lg border-4 border-primary/30">
          {getInitial(studentName)}
        </div>
      </div>
      {/* Welcome Content */}
      <div className="flex-1 text-white relative z-10">
        <h1 className="text-3xl font-heading font-bold mb-2 drop-shadow-lg" style={{ color: "#fff" }}>
          {getGreeting()}, {studentName || "Student"}!
        </h1>
        <p className="text-lg font-body opacity-90 mb-2 drop-shadow" style={{ color: "#fff" }}>
          Welcome back to your academic dashboard.
        </p>
        <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-6 justify-center sm:justify-start text-base font-body mt-2">
          <span className="inline-block px-4 py-2 rounded-full bg-white/20 text-white font-semibold border border-white/30 drop-shadow" style={{ color: "#fff" }}>
            Academic Year: {getAcademicYear()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;